import $api from "@/lib/queries/openapi";

export default function useGetLineItems(
  quoteRevisionId: string | undefined,
  teamSlug: string | undefined,
) {
  const { data } = $api.useQuery(
    "get",
    "/api/teams/{team_slug}/quote_revisions/{id}/line_items",
    {
      params: {
        path: {
          team_slug: teamSlug!,
          id: quoteRevisionId!,
        },
      },
    },
    {
      enabled: !!quoteRevisionId && !!teamSlug,
    },
  );

  return data;
}
